import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { getToken } from '../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../constants/api';

export const AutoCompleteInput = ({ col, value, onChange }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [response, setResponse] = useState([]);

  const [displayValue, setDisplayValue] = useState(value || '');
  const [timeoutId, setTimeoutId] = useState(null);
  const token = getToken();

  const fetchSuggestions = async (query) => {
    if (!query) return setSuggestions([]);
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete-v2/${col.inputId}?query=${query}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      // console.log('response auto:', response.data);
      setSuggestions(response.data.results);
      setResponse(response.data);
    } catch (err) {
      console.error('Error fetching suggestions:', err.message);
    }
  };
  // console.log('resp:', response);
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setDisplayValue(newValue);
    if (timeoutId) clearTimeout(timeoutId);
    setTimeoutId(setTimeout(() => fetchSuggestions(newValue), 300));
  };

  const handleSelect = async (item) => {
    setDisplayValue(item.name);
    setSuggestions([]);
    if (response.load_info_sql_query) {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/load-info/${col.inputId}/${item.id}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        // console.log('response load info:', response.data);
        onChange(item.id, item.name, response.data.info);
      } catch (err) {
        console.error('Error fetching suggestions:', err.message);
      }
    } else {
      onChange(item.id, item.name);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        className="form-control form-control-sm"
        value={displayValue}
        onChange={handleInputChange}
        autoComplete="off"
      />
      {suggestions.length > 0 && (
        <ul
          className="dropdown-menu show"
          style={{ maxHeight: '150px', overflowY: 'auto', width: '100%' }}
        >
          {suggestions.map((item) => (
            <li key={item.id}>
              <button
                className="dropdown-item"
                type="button"
                onClick={() => handleSelect(item)}
              >
                {item.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteInput;
